import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ArrowRight } from "react-bootstrap-icons";

const solutions = {
    "Advanced Train Collision Avoidance Systems": [
        {
            id: "01",
            title: "EULYNX Protocol Box",
            description:
                "A compact, interoperable gateway enabling seamless communication between legacy railway systems and next-gen EULYNX-compliant interfaces. Designed for modernization without disruption.",
            image: "/solutions03.webp",
        },
        {
            id: "02",
            title: "Design Document Automation",
            description:
                "Streamlines the creation of complex engineering documents with speed, accuracy, and consistency. Reduce manual effort, minimize errors, and accelerate project timelines.",
            image: "/solutions04.webp",
        },
    ],
    "Smart Yard Solutions": [
        {
            id: "03",
            title: "Safety Management",
            description:
                "A structured approach to identifying, assessing, and mitigating risks across operations. Ensures compliance, protects assets, and fosters a culture of safety.",
            image: "/solutions03.webp",
        },
        {
            id: "04",
            title: "Asset Management",
            description:
                "Optimize the lifecycle, performance, and value of critical infrastructure. Gain visibility, ensure uptime, and make data-driven decisions with confidence.",
            image: "/solutions04.webp",
        },
    ],
    "Operations & Maintenance": [
        {
            id: "05",
            title: "Metro Corridors",
            description:
                "A compact, interoperable gateway enabling seamless communication between legacy railway systems and next-gen EULYNX-compliant interfaces. Designed for modernization without disruption.",
            image: "/solutions03.webp",
        },
    ],
};

export default function SolutionTabs() {
    const [activeTab, setActiveTab] = useState(
        "Advanced Train Collision Avoidance Systems"
    );

    return (
        <div className="py-5 p-md-5 rounded-3 shadow" style={{ border: "3px solid rgba(0, 0, 0, 0.08)" }}>
            {/* Tabs */}
            <ul className="nav nav-tabs mb-4 border-0 flex-wrap justify-content-center justify-content-md-between gap-2 gap-md-0 custom-tab-height">
                {Object.keys(solutions).map((tab) => (
                    <li className="nav-item d-flex flex-column align-items-center text-center" key={tab}>
                        <button
                            className={`nav-link ${tab === activeTab ? "active fs-18 fw-bold border-0" : "fs-16 text-black border-0"}`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab.split(' ').map((word, i) => (
                                <React.Fragment key={i}>
                                    {word}
                                    {(i + 1) % 3 === 0 ? <br /> : ' '}
                                </React.Fragment>
                            ))}
                        </button>
                        <div className={`${tab === activeTab ? "border-primary-blue-3 w-50 rounded-4 mt-1" : ""}`}></div>
                    </li>
                ))}
            </ul>


            <div className="">
                {solutions[activeTab].map((item) => (
                    <div
                        key={item.id}
                        className="row bg-white rounded-4 p-4 mb-4 mx-0"
                    >
                        <div className="col-md-6 pe-md-4 mb-3 mb-md-0 d-flex flex-column justify-content-between">
                            <div>
                                <span className="badge fw-normal rounded-pill border-primary-blue text-primary-blue px-3 py-1 mb-3 fs-16">
                                    <span className="me-2 text-success fs-16">●</span>Solution {item.id}
                                </span>
                            </div>
                            <div>
                                <p className="fs-36 fw-bold" style={{ lineHeight: '1.2' }}>{item.title}</p>
                                <p className="text-primary-blue" style={{ lineHeight: '1.3' }}>{item.description}</p>
                            </div>
                            {/* <div>
                                <button
                                    onClick={() => window.location.href = "solutions/products"}
                                    className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-4 bg-primary-blue"
                                >
                                    <span className="mx-3 fs-14">View Solution</span>
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-circle"
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                            backgroundColor: '#ffffff',
                                        }}
                                    >
                                        <ArrowRight color="#193E6C" />
                                    </div>
                                </button>
                            </div> */}
                            <div>
                                <button
                                    disabled
                                    className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-4 bg-secondary"
                                    style={{ opacity: 0.6, cursor: "not-allowed" }}
                                >
                                    <span className="mx-3 fs-14">View Solution</span>
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-circle"
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                            backgroundColor: '#ffffff',
                                        }}
                                    >
                                        <ArrowRight color="#193E6C" />
                                    </div>
                                </button>

                            </div>
                        </div>

                        <div className="col-md-6">
                            <img
                                src={item.image}
                                alt={item.title}
                                className="rounded-3 w-100 h-100"
                                style={{ objectFit: "cover", maxHeight: '290px' }}
                            />
                        </div>
                    </div>
                ))}

            </div>
        </div>
    );
}
